module.exports = __webpack_public_path__ + "media/cow_3.39ffc73e.mp3";